import { useTranslation } from 'react-i18next';
import GooglePlayButton from '../../../../../common/assets/images/maintenance/google-play-download-button.svg';
import AppStoreButton from '../../../../../common/assets/images/maintenance/app-store-download-button.svg';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';
import { Link } from 'react-router-dom';

export default function DownloadApp() {
  const { t: translate } = useTranslation();

  return (
    <div className="footer-download-app">
      <p className="footer-download-app-tagline">
        {translate(resources.footer.downloadAppTagline)}
      </p>
      <div className="footer-download-app-badges">
        <div className="footer-download-app-qr">
          <Icons.AppDownloadQR />
        </div>
        <div className="footer-download-app-stores">
          <Link
            to={translate(resources.company.googlePlayLink)}
            target="_blank"
            rel="noreferrer"
          >
            <img src={GooglePlayButton} alt="Download from Google Play" />
          </Link>
          <Link
            to={translate(resources.company.appStoreLink)}
            target="_blank"
            rel="noreferrer"
          >
            <img src={AppStoreButton} alt="Download from App Store" />
          </Link>
        </div>
      </div>
      <div className="footer-social-links">
        <Link
          to={translate(resources.company.linkedInLink)}
          target="_blank"
          rel="noreferrer"
        >
          <Icons.In />
        </Link>
        <Link
          to={translate(resources.company.fBLink)}
          target="_blank"
          rel="noreferrer"
        >
          <Icons.Fb />
        </Link>
        <Link
          to={translate(resources.company.instagramLink)}
          target="_blank"
          rel="noreferrer"
        >
          <Icons.Instagram />
        </Link>
        <Link
          to={translate(resources.company.youTubeLink)}
          target="_blank"
          rel="noreferrer"
        >
          <Icons.Yt />
        </Link>
      </div>
    </div>
  );
}
